import { Component, OnInit, inject, ViewChild, ElementRef } from '@angular/core';

import { HttpClient, HttpHeaders } from '@angular/common/http';
import { of } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SystemApp } from '../../constans/SystemConfigurations';
import { ApiUrl } from '../../shared/models/apiurl.models';
import {ContactMenuComponent} from "../contact-menu/contact-menu.component";
import {Router} from "@angular/router";
import { DragScrollDirective } from '../../shared/directives/drag-scroll.directive';
import { CardBizBadgesComponent, CardDealerComponent } from '../card-seller/card-seller.component';

interface NadlanCity {
  id: number;
  nameHe: string;
  nameEng: string;
  areaName: string;
}

interface NadlanStreet {
  id: number;
  nameHe: string;
}

interface NadlanImage {
  image: string;
  SortNum: number | null;
}

interface Armature {
  id: number;
  ArmatureDesc: string;
}

interface AdsRoute {
  id: number;
  title: string;
  level: string;
}

interface UserContact {
  id: number;
  contactPerson: string;
  phoneNumber: string;
}

interface SconderyCategory {
  id: number;
  name: string;
  subCategory: string;
}

interface TypeOfNadlan {
  id: number;
  nameHe: string;
}

interface StatusOfNadlan {
  id: number;
  nameHe: string;
}

interface RoomsNum {
  id: number;
  numberOfRooms: number;
}

interface ParkingNumber {
  id: number;
  numberParking: number;
}

interface Nadlan {
  id: number;
  name: string;
  images: NadlanImage[];
  armatureList: Armature[] | null;
  adsRoute: AdsRoute | null;
  sconderyCategory: SconderyCategory | null;
  StatusOfNadlan: StatusOfNadlan | null;
  TypeOfNadlan: TypeOfNadlan | null;
  userContactDetails: UserContact | null;
  City: NadlanCity | null;
  Street: NadlanStreet | null;
  RoomsNum: RoomsNum | null;
  ParkingNumber: ParkingNumber | null;
  Balcony: number | null;
  FreeText: string | null;
  price: number | null;
  numberOfPays: number | null;
  HomeNum: number | null;
  Floor: number | null;
  TotalFloor: number | null;
  OnColumns: boolean | null;
  Neighborhood: string | null;
  Area: string | null;
  condo: number | null;
  arnona: number | null;
  buildingMeter: number | null;
  buildingMeterTotal: number | null;
  availabilityEntrance: boolean | null;
  flexible: boolean | null;
  longTime: boolean | null;
  statusAds: string;
  /** Present on every product; used to detect internal (admin) ads merged into this listing. */
  resourcetype?: string;
  /** Generic Product fields — only populated on internal ads, not on real Nadlan rows. */
  description?: string;
  city?: { id: number; nameHe: string } | null;
}

interface NadlanResponse {
  page_size: number;
  object_list: Nadlan[];
}

@Component({
    selector: 'app-nadlan-listings',
    imports: [ContactMenuComponent, DragScrollDirective, CardBizBadgesComponent, CardDealerComponent],
    templateUrl: 'nadlan-bar.component.html',
    styleUrls: ['nadlan-bar.component.scss']
})
export class NadlanListingsComponent implements OnInit {
  private http = inject(HttpClient);
  private options = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Authorization': this.apiKey.getJWTToken()
    })
  };

  listings: Nadlan[] = [];
  isLoading = false;
  error: string | null = null;

  @ViewChild('nadlanTrack') nadlanTrack!: ElementRef<HTMLElement>;

  private apiUrl = SystemApp.base_url_api + '/clientAjax/productVFilteriewSet';

  constructor(private apiKey: ApiUrl, private route: Router) {}

  ngOnInit(): void {
    this.loadListings();
  }

  loadListings(): void {
    this.isLoading = true;
    this.error = null;

    this.http
        .post<NadlanResponse>(
            `${this.apiUrl}?limit=36&offset=1&model_class=nadlan`,
            {},
            { headers: this.options.headers }
        )
        .pipe(
            catchError((err) => {
              this.error = err.message;
              this.isLoading = false;
              return of(null);
            })
        )
        .subscribe((res) => {
          if (res) {
            this.listings = res.object_list;
          }
          this.isLoading = false;
        });
  }

  scrollLeft(): void {
    this.nadlanTrack.nativeElement.scrollBy({ left: -360, behavior: 'smooth' });
  }

  scrollRight(): void {
    this.nadlanTrack.nativeElement.scrollBy({ left: 360, behavior: 'smooth' });
  }

  onImageError(event: Event): void {
    (event.target as HTMLImageElement).src =
        'https://placehold.co/400x260/e8e4df/8a8580?text=🏠';
  }

  formatPrice(price: number | null): string {
    if (!price) return 'ליצירת קשר';
    return '₪' + price.toLocaleString();
  }

  getCategoryIcon(subCategory: string): string {
    switch (subCategory) {
      case 'BUYING': return '🏷️';
      case 'RENTAL': return '🔑';
      default: return '🏠';
    }
  }

  getCategoryLabel(subCategory: string): string {
    switch (subCategory) {
      case 'BUYING': return 'למכירה';
      case 'RENTAL': return 'להשכרה';
      default: return subCategory;
    }
  }

  isPromoted(listing: Nadlan): boolean {
    return !!listing.adsRoute && listing.adsRoute.level !== 'LEVEL1';
  }

  /**
   * Internal (admin) ads linked to this category are merged into the same
   * listing by the backend. They only carry the generic Product fields
   * (name/price/images/description/city), none of the nadlan-specific ones —
   * so they need a simpler card.
   */
  isInternalAd(listing: Nadlan): boolean {
    return (listing.resourcetype || '').toLowerCase() === 'internalads';
  }
  openPage(id:any){
    this.route.navigate([`single/${id}`])
  }

  getAdsBadge(level: string): string {
    switch (level) {
      case 'LEVEL3': return '⭐ VIP';
      case 'LEVEL2': return '🔥 מודגשת';
      default: return '';
    }
  }

  navigateToPage() {
    this.route.navigate([`shop/nadlan`])
  }
}